// extracted by mini-css-extract-plugin
export default {"alternativeText":"_3biD9lb","suggestedTerm":"_2f22PFS"};